module.exports = __webpack_public_path__ + "static/media/storePurchase_25_30.8da508ab.png";